import { message, Upload } from 'antd';
import { getLangList } from "@/lib/i18n";

export const convertBase64ToPicture = (value: any) => {
  return `data:image/gif;base64,${value}`;
};

const onChange = (info: any) => {
  if (info.file.status === 'done') {
    message.success(`${info.file.name} file uploaded successfully`);
  } else if (info.file.status === 'error') {
    message.error(`${info.file.name} file upload failed.`);
  }
}

const beforeUpload = (file: any) => {
  const errorT: any = getLangList("error");
  const isTooLarge = file.size / 1024 / 1024 > 5;

  if (isTooLarge) {
    message.error(errorT.IMAGE_TOO_LARGE);
    return Upload.LIST_IGNORE;
  }
  return false;
}

export const avatarUploadProps: any = {
  accept: "image/png, image/jpeg, image/jpg",
  onChange,
  beforeUpload,
  maxCount: 1,
  listType: "picture",
};

export const otherFilesUploadProps: any = {
  maxCount: 5,
  multiple: true,
  showUploadList: {
    showRemoveIcon: false,
  },
};

export const fileUploadProps: any = {
  onChange,
  beforeUpload,
  maxCount: 1,
  listType: "picture",
};

export const excelUploadProps: any = {
  accept: ".xlsx, .xls, .csv",
  maxCount: 1,
  itemRender: () => null,
};

export const normFile = (e: any) => {
  if (Array.isArray(e)) {
    return e;
  }
  return e && e.fileList;
};